/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - CSS
 */
import './styles/Widget.css'

export default class Widget extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
    }

    render() {
        return (
            <div
                className={`widget ${this.props.className || ''}${(this.props.shadow) ? ' widget--shadow' : ''}`}
            >
                <div>
                    {this.props.children}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Widget/Widget.tsx